// What a gateway settings row does for the gateways that link it, and which of
// those a gateway API serves (public.gateway_api_kind, V28 in x-backend). A payin
// or payout row starts the transaction; a callback row is where its result comes
// from.
export const GATEWAY_API_KIND = ['payin', 'payout', 'payin_callback', 'payout_callback'];
